// The date this build was made (UTC), the same in the prerendered HTML and in the browser.
export function getBuildDate() {
  const stamp = import.meta.env.VITE_BUILD_DATE;
  return stamp ? new Date(stamp) : new Date();
}

// The latest completed month, whose best-of list is final.
export function getLatestBestOfYearMonth(now = getBuildDate()) {
  const previous = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1));
  return `${previous.getUTCFullYear()}-${String(previous.getUTCMonth() + 1).padStart(2, "0")}`;
}
